// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2JOgE","rootCenter":"LoadMoreObserver_rootCenter__Vp8CU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__20_Ed"};